import React, { Component } from 'react';
import update from 'immutability-helper';
import Loading from '../Loading.js';
import NamezzzFunction from '../../Fields/NamezzzFunction.js';
import NamezzzSector from '../../Fields/NamezzzSector.js';
import FormAutocomplete from '../../Fields/FormAutocomplete';
import FormList from '../../Fields/FormList.js';
import Questions from './Questions.js';

import { getSectors, postSector, deleteSector, getFunctions, postFunction, deleteFunction, getPersonRegions, deletePersonRegions, postPersonRegions } from '../../Api/UserActions.js'
import { getJsonItem } from '../../Utilities/JsonFunctions.js'
import { getTranslation } from '../../Utilities/GetTranslation.js'
import { getRegions, getAllRegions } from '../../Api/Namezzz.js';
import { getObjectiveFunctionsFormList, getObjectiveSectorsFormList, getPersonRegionsFormList } from '../../Utilities/SnsFunctions.js';

declare var $;
declare var globalSns;

class JobPreferences extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputParentRegionId: 101,
            inputFunction: "",
            inputSector: "",
            childRegions: [],
            showValidation: false
        }

        this.handleValueChange = this.handleValueChange.bind(this);
        this.onFunctionChange = this.onFunctionChange.bind(this);
        this.onSectorChange = this.onSectorChange.bind(this);
        this.onChangeRegion = this.onChangeRegion.bind(this);
        this.addFunction = this.addFunction.bind(this);
        this.addSector = this.addSector.bind(this);
        this.addRegion = this.addRegion.bind(this);
        this.addOrSetRegion = this.addOrSetRegion.bind(this);
        this.deleteFunction = this.deleteFunction.bind(this);
        this.deleteSector = this.deleteSector.bind(this); 
        this.deleteRegion = this.deleteRegion.bind(this); 
    }

    componentWillMount() {
        this.loadData();
    }

    componentDidUpdate() {
        this.$ctrlChildRegions = $(this.ctrlChildRegions);
        this.$ctrlChildRegions.selectpicker({dropupAuto: false, size: 15});
        this.$ctrlChildRegions.selectpicker('deselectAll');
        this.$ctrlChildRegions.selectpicker("toggle");
    }

    loadData() {
        getAllRegions(globalSns.languageId, (data) => {
            this.setState({
                allRegions: data
            });
        });
        getRegions(globalSns.languageId, this.state.inputParentRegionId, (data) => {
            this.setState({
                childRegions: data
            });
        });

        getFunctions(globalSns.languageId, (data) => {
            this.setState({
                objectiveFunctions: data
            });
        });
        getSectors(globalSns.languageId, (data) => {
            this.setState({
                objectiveSectors: data
            })
        });
        getPersonRegions(globalSns.languageId, (data) => {
            this.setState({
                personRegions: data
            });
        });
    }

    async isValidated() {
        // For job 0: minimum 1 function and region are needed
        if (globalSns.jobId !== 0) {
            return true;
        }

        this.setState({
            showValidation: true
        });

        if (this.state.objectiveFunctions != null && this.state.objectiveFunctions.length < 1) {
            return false;
        }

        if (this.state.personRegions != null && this.state.personRegions.length < 1) {
            return false;
        }

        return true;
    }    

    handleValueChange(e) {
        this.setState({
            [e.target.id] : e.target.value
        }); 
    }

    onFunctionChange(e, id, synonymId) {
        this.setState({
            inputFunction: e.target.value,
            inputFunctionId: id,
            inputFunctionSynonymId: synonymId
        })
    }

    onSectorChange(e, id, synonymId) {
        this.setState({
            inputSector: e.target.value,
            inputSectorId: id,
            inputSectorSynonymId: synonymId
        })
    }

    onChangeRegion(e, id) {
        if (id == null) {
            this.setState({
                inputParentRegion: e.target.value,
                inputParentRegionId: id,
                childRegions: []
            });
            return;
        }

        getRegions(globalSns.languageId, id, (data) => {
            this.setState({
                inputParentRegion: e.target.value,
                inputParentRegionId: id,
                childRegions: data
            });
        });
    }

    addFunction(e) {
        // not selected function
        if (this.state.inputFunction.trim() === "") {
            return;
        }

        postFunction(null, this.state.inputFunctionId, this.state.inputFunctionSynonymId, this.state.inputFunction, (data) => {
            if (data != null && data.id != null) {
                this.setState({
                    objectiveFunctions: update(this.state.objectiveFunctions, {$push: [data]}),
                    inputFunction: "",
                    inputFunctionId: null,
                    inputFunctionSynonymId: null
                });
            }
        });
    }

    addSector(e) {
        // not selected sector
        if (this.state.inputSector.trim() === "") {
            return;
        }
        postSector(null, this.state.inputSectorId, this.state.inputSectorSynonymId, this.state.inputSector, (data) => {
            if (data != null && data.id != null) {       
                this.setState({
                    objectiveSectors: update(this.state.objectiveSectors, {$push: [data]}),
                    inputSector: "",
                    inputSectorId: null,
                    inputSectorSynonymId: null
                })
            }
        });
    }

    addRegion(e) {
        if (this.state.childRegions.length === 1) {
            postPersonRegions(this.state.inputParentRegionId, this.state.inputParentRegion, (data) => {
                if (data == null) {
                    return;
                }
                this.setState({
                    personRegions: update(this.state.personRegions, {$push: [data]})
                });
            });
        } else {
            var _this = this;
            $("option:selected", this.$ctrlChildRegions).each(function () {
                postPersonRegions($(this).val(), $(this).text(), (data) => {
                    if (data == null) {
                        return;
                    }
                    _this.setState({
                        personRegions: update(_this.state.personRegions, {$push: [data]})
                    }); 
                });
            });
        }

        this.$ctrlChildRegions.selectpicker('deselectAll');
    }

    addOrSetRegion(e, id) {
    }

    deleteFunction(id) {
        deleteFunction(id, () => {
            var item = getJsonItem(this.state.objectiveFunctions, "id", id);
            var index = this.state.objectiveFunctions.indexOf(item);

            this.setState({
                objectiveFunctions: update(this.state.objectiveFunctions, {$splice: [[index, 1]]})
            })            
        });
    }

    deleteSector(id) {
        deleteSector(id, () => {
            var item = getJsonItem(this.state.objectiveSectors, "id", id);
            var index = this.state.objectiveSectors.indexOf(item);

            this.setState({
                objectiveSectors: update(this.state.objectiveSectors, {$splice: [[index, 1]]})
            })
        });
    }

    deleteRegion(id) {
        deletePersonRegions(id, () => {
            var item = getJsonItem(this.state.personRegions, "id", id);
            var index = this.state.personRegions.indexOf(item);

            this.setState({
                personRegions: update(this.state.personRegions, {$splice: [[index, 1]]})
            })
        });
    }

    render() {

        if (this.state.allRegions == null || this.state.objectiveSectors == null || this.state.objectiveFunctions == null || this.state.personRegions == null) {
            return (
                <Loading/>
            );
        }

        let isRequired = (globalSns.jobId === 0) ? <span className="required-mark">*</span> : null;

        return (
            <div>

                { (globalSns.jobId > 0) ?
                    <p><em>{getTranslation("sns.webparts.jobpreferences.sub")}</em></p> : ""
                }
                
                <h4 className="legend-title">{getTranslation("sns.webparts.jobpreferences.cat-functions")}{isRequired}</h4>
                <p><em>{getTranslation("sns.webparts.jobpreferences.functions.sub")}</em></p>

                <FormList values={getObjectiveFunctionsFormList(this.state.objectiveFunctions)} title={getTranslation("sns.webparts.jobpreferences.selected.functions")} isUserData={true}
                    showDelete={true} onDelete={this.deleteFunction} />
                                    
                <div className="tr">
                    <NamezzzFunction id="inputFunction" 
                        value={this.state.inputFunction} 
                        seqlang={globalSns.languageId}
                        required={globalSns.jobId === 0} 
                        validationText={globalSns.jobId === 0 && this.state.objectiveFunctions < 1 ? getTranslation("basicform.erroremptyvalue") : ""}
                        showValidation={this.state.showValidation}
                        onChange={this.onFunctionChange} 
                        onEnter={this.addFunction} />
                    <div className="td">
                        <input type="button" className="FormButton btn btn-primary blue act" id="addFunction" value={getTranslation("sns.webparts.jobpreferences.addfunction")} onClick={this.addFunction} />
                    </div>
                </div>

                <h4 className="legend-title">{getTranslation("sns.webparts.jobpreferences.cat-sectors")}</h4>
                <p><em>{getTranslation("sns.webparts.jobpreferences.sectors.sub")}</em></p>

                <FormList values={getObjectiveSectorsFormList(this.state.objectiveSectors)} title={getTranslation("sns.webparts.jobpreferences.selected.sectors")} isUserData={true}
                    showDelete={true} onDelete={this.deleteSector} />

                <div className="tr">
                    <NamezzzSector id="inputSector" seqlang={globalSns.languageId} value={this.state.inputSector} onChange={this.onSectorChange} onEnter={this.addSector} />
                    <div className="td">
                        <input type="button" className="FormButton btn btn-primary blue act" id="addSector" value={getTranslation("sns.webparts.jobpreferences.addsector")} onClick={this.addSector} />
                    </div>
                </div>
                
                <h4 className="legend-title">{getTranslation("sns.webparts.jobpreferences.cat-regions")}{isRequired}</h4>

                <FormList values={getPersonRegionsFormList(this.state.personRegions)} title={getTranslation("sns.webparts.jobpreferences.selected.regions")} isUserData={true}
                    showDelete={true} onDelete={this.deleteRegion} />

                <div className="tr">              
                    <FormAutocomplete id="inputParentRegion"
                        value={this.state.inputParentRegionId}
                        seqlang={globalSns.languageId} data={this.state.allRegions}
                        required={globalSns.jobId === 0} 
                        validationText={globalSns.jobId === 0 && this.state.personRegions < 1 ? getTranslation("sns.webparts.jobpreferences.selectregion") : ""}
                        showValidation={this.state.showValidation}
                        onChange={this.onChangeRegion} /> 
                    <div className="td">
                    {
                        (this.state.childRegions.length === 1) ?
                            <input type="button" className="FormButton btn btn-primary blue act" id="addRegion" value={getTranslation("sns.webparts.jobpreferences.addregion")} onClick={this.addRegion} />
                            : ""
                    }
                    </div>
                </div>
                {
                    (this.state.childRegions.length > 1) ? 
                        <div className="tr">
                            <div className="EditingFormValueCell td">
                                <div className="text-right">
                                    {getTranslation("sns.webparts.jobpreferences.subregions")}
                                </div>
                                <div className="text-right">
                                    <select ref={el => this.ctrlChildRegions = el} className="selectpicker" multiple>
                                        {
                                            this.state.childRegions.map((region) =>
                                                <option key={region.id} value={region.id} className={"lvl" + region.level}>{region.name}</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </div> 
                            <div className="td">
                                <input type="button" className="FormButton btn btn-primary blue act" id="addRegion" value={getTranslation("sns.webparts.jobpreferences.addregion")} onClick={this.addRegion} />
                            </div>
                        </div>
                        : ""
                }
                {
                    (globalSns.jobId === 0) ?
                        <Questions ref="questions" job={this.props.job} showTitle={true} /> :
                        ""
                }
            </div>
        );
    }
}

export default JobPreferences;


// WEBPACK FOOTER //
// ./src/Components/Tabs/JobPreferences.js